export default angular.module('articles', [])
    /**
     * @ngdoc controller
     * @name article.controller:article
     * @description
     * Scope for a list of articles
     */
    // @ngInject
    .controller('articles', function ($scope, $http, $log, $timeout) {
        var last_request = 0; // track each request to dump invalid ones
        $scope.endpoint = null;
        $scope.method = 'GET';
        $scope.offset = 0;
        $scope.tags = null;
        $scope.years = null;
        $scope.category = null;
        $scope.articles = [];
        $scope.has_more_articles = true;
        $scope.isLoading = false;

        // Load next set of Articles from endpoint configuration
        // to allow "infinite" article loading withour reload
        $scope.loadArticles = function () {
            var current_request = ++last_request; // keep track of requests, dump old ones
            if ($scope.endpoint === null) {
                return $log.error('AJAX URL has not been provided');
            }
            $scope.offset++;
            $timeout(function () {
                $scope.isLoading = true;
            });
            $http({
                url: $scope.endpoint,
                method: $scope.method,
                params: {
                    'offset': $scope.offset,
                    'selectedTags': $scope.tags,
                    'selectedYears': $scope.years,
                    'category': $scope.category
                }
            })
                .then(function (response) {
                    if (current_request !== last_request) {
                        return;
                    }
                    else {
                        $scope.isLoading = false;
                        $scope.has_more_articles = response.data.HasMoreArticles;
                        $scope.articles = $scope.articles.concat(response.data.Results);
                    }
                })
                .catch(function (error) {
                    if (current_request === last_request) {
                        $log.error(error);
                        $scope.isLoading = false;
                    }
                });
        };
    })
    /**
     * @ngdoc directive
     * @name article.directive:articles
     * @restrict A
     * @description
     * Creates a new scope and controller for each group instance
     */
    // @ngInject
    .directive('articles', function () {
        return {
            scope: true,
            controller: 'articles',
            restrict: 'AE',
            link: function ($scope, $element, attrs) {
                $scope.endpoint = attrs.articlesEndpoint || $scope.endpoint;
                $scope.method = attrs.articlesEndpointMethod || $scope.method;
                $scope.offset = attrs.articlesOffset || $scope.offset;
            }
        };
    })
    /**
     * @ngdoc directive
     * @name article.directive:loadArticles
     * @restrict A
     * @description
     * When clicked loads the next X articles into the controller
     * to be displayed, without a reload
     */
    // @ngInject
    .directive('loadArticles', function () {
        return {
            restrict: 'AE',
            link: function ($scope, $element, attrs) {
                if ($element.hasClass('article-listing-show-more--inactive')) {
                    $scope.has_more_articles = false;
                }
                $element.on('click', function (e) {
                    e.preventDefault();
                    if ($scope.has_more_articles) {
                        $scope.loadArticles();
                    }
                });
                $scope.$watch(function () {
                    return $scope.isLoading;
                }, function (isLoading) {
                    $element.toggleClass('form-input--button--active', isLoading === true);
                });
                $scope.$watch('has_more_articles', function (has_more_articles) {
                    $element.toggleClass('article-listing-show-more--inactive', !has_more_articles);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name article.directive:filterTags
     * @restrict A
     * @description
     * Allows a set of tag filters to be applied to the AJAX article request
     */
    // @ngInject
    .directive('filterTags', function () {
        return {
            restrict: 'AE',
            link: function ($scope, $element, attrs) {
                $scope.tags = attrs.filterTags;
            }
        };
    })
    /**
     * @ngdoc directive
     * @name article.directive:filterYears
     * @restrict A
     * @description
     * Allows a set of year filters to be applied to the AJAX article request
     */
    // @ngInject
    .directive('filterYears', function () {
        return {
            restrict: 'AE',
            link: function ($scope, $element, attrs) {
                $scope.years = attrs.filterYears;
            }
        };
    })
    /**
     * @ngdoc directive
     * @name article.directive:filterCategories
     * @restrict A
     * @description
     * Allows a specifica category to be applied to the AJAX article request
     */
    // @ngInject
    .directive('filterCategory', function () {
        return {
            restrict: 'AE',
            link: function ($scope, $element, attrs) {
                $scope.category = attrs.filterCategory;
            }
        };
    })
    /**
     * @ngdoc directive
     * @name article.directive:column
     * @restrict A
     * @description
     * Appends a space character between each column to ensure style
     */
    // @ngInject
    .directive('column', function () {
        return {
            restrict: 'AE',
            compile: function () {
                return {
                    pre: function ($scope, $element) {
                        $element.after('&nbsp; &nbsp;');
                    }
                };
            }
        };
    });
